import { ICell as Cell } from 'models/interfaces/spreadsheet-types/core-types';
import { SELECTION } from 'pages/Valuations/approaches/guidelinePublicCompanies/constants';
import { percentileOptions } from 'pages/Valuations/approaches/guidelinePublicCompanies/gpc/config/getRowConfig';
import { selectionChange } from 'pages/ValuationsAllocation/util';

function percentileChange<T extends Omit<Cell, 'dependencies' | 'options' | 'providers' | 'sheet'>>(
  cell: T,
  value: any,
  cells: { [key: string]: T },
  changes: { cell: T; value: string | number | null | undefined }[],
  useMultiplePremiumDiscount = false
) {
  const previousSelectionOption = percentileOptions[Number(cell.value) - 1]?.label;
  const currentOption = percentileOptions[value - 1]?.label;
  const selectionUpdates = {
    [cell.alias]: value,
  };
  Object.values(cells)
    .filter(selectionCell => selectionCell.alias === SELECTION && selectionCell.value === previousSelectionOption)
    .forEach(selectionCell => {
      changes.push({
        cell: selectionCell,
        value: currentOption,
      });

      selectionChange(cells, changes, selectionCell, currentOption, useMultiplePremiumDiscount, selectionUpdates);
    });
}
export default percentileChange;
